import {
  Box,
  Checkbox,
  Collapse,
  IconButton,
  InputLabel,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { ExpandMore, Folder } from "@mui/icons-material";
import CustomizedCheckbox from "../../common/formElements/Checkbox";
import React, { memo, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import OptionSwitch from "../../common/formElements/OptionSwitch";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { FormikProps, useFormikContext } from "formik";
import { Data } from "../../store/usergroup/types";
import { get } from "lodash";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";

interface Props {
  permissionKey: string;
  userGroup: any;
  permissions: any;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    txt: {
      color: "var(--dmg-primary)",
      textDecoration: "none",
      fontWeight: "bold",
      paddingRight: "0",
    },
    icon: { color: "var(--dmg-primary)" },
    isChild: {
      paddingLeft: theme.spacing(2),
    },
  };
});

const PermissionDetail = (props: Props) => {
  const classes = useStyles();

  const [openSettings, setOpenSettings] = useState(true);
  const { permissionKey, userGroup, permissions } = props;

  const renderPermissionKey = (key: string) => {
    if (key) {
      return key.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    }
    return "";
  };

  // const access = get(userGroup, `${permissionKey}.Access`, {});
  // const SectionAccess = userGroup[permissionKey].SectionAccess || null;
  const access = get(userGroup, `${permissionKey}.Access`, {});
  const SectionAccess = permissions[permissionKey].SectionAccess || null;
  let indeterminateR = false;
  let indeterminateU = false;
  const childAccess = get(userGroup, `${permissionKey}.SectionAccess`, {});
  if (SectionAccess) {
    indeterminateR = Object.entries(childAccess)
      .map(([key, obj]) => obj)
      .some((obj) => !get(obj, "Access.R", false));
    indeterminateU = Object.entries(childAccess)
      .map(([key, obj]) => obj)
      .some((obj) => !get(obj, "Access.U", false));
  }

  return (
    <Box
      key={permissionKey}
      sx={{ p: 2 }}
      style={{
        width: "100%",
        border: "1px solid var(--dmg-gray-200)",
        marginBottom: "10px",
        paddingRight: "10px",
      }}
    >
      <ListItem className={classes.txt}>
        <ListItemIcon>
          <Folder color="primary"></Folder>
        </ListItemIcon>
        <ListItemText
          primary={renderPermissionKey(
            permissionKey === "UserGroup" ? "Role" : permissionKey
          )}
        />
        <ListItemSecondaryAction>
          <Box display="flex" justifyContent="flex-end">
            <Box
              flexGrow={1}
              width={65}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <InputLabel shrink>Read</InputLabel>
              <Checkbox
                indeterminate={indeterminateR && access.R}
                checked={Boolean(access.R)}
                name={permissionKey}
                disabled
              />
            </Box>
            <Box
              width={65}
              flexGrow={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <InputLabel shrink>Update</InputLabel>
              <Checkbox
                indeterminate={indeterminateU && access.U}
                checked={Boolean(access.U)}
                name={permissionKey}
                disabled
              />
            </Box>
            <Box
              width={65}
              flexGrow={1}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <InputLabel shrink>Create</InputLabel>
              <Checkbox
                checked={access.C}
                name={`attributes.Permission.${permissionKey}.Access.C`}
                disabled
              />
            </Box>
            <Box
              width={65}
              flexGrow={1}
              mr={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <InputLabel color="primary" shrink>
                Delete
              </InputLabel>
              <Checkbox
                checked={access.D}
                name={`attributes.Permission.${permissionKey}.Access.D`}
                disabled
              />
            </Box>
          </Box>
        </ListItemSecondaryAction>
        {SectionAccess && (
          <IconButton
            type="button"
            onClick={() => setOpenSettings(!openSettings)}
            edge="start"
          >
            {openSettings ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </ListItem>
      {SectionAccess && (
        <Collapse in={openSettings} timeout="auto" unmountOnExit>
          <Divider />
          <List
            style={{ marginTop: "10px", paddingLeft: "30px" }}
            component="div"
            disablePadding
          >
            {Object.keys(SectionAccess || {}).map((sectionKey: string, idx) => {
              const child = get(childAccess, `${sectionKey}.Access`, {});
              return (
                <ListItem
                  style={{
                    borderBottom:
                      idx < Object.keys(SectionAccess || {}).length - 1
                        ? "1px solid var(--dmg-gray-200)"
                        : "",
                  }}
                  key={sectionKey}
                  className={classes.isChild}
                >
                  <ListItemIcon>
                    <Folder color="secondary"></Folder>
                  </ListItemIcon>
                  <ListItemText primary={renderPermissionKey(sectionKey)} />
                  <ListItemSecondaryAction style={{ marginRight: "130px" }}>
                    <Box display="flex" justifyContent="flex-end">
                      <Box
                        width={65}
                        flexGrow={1}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <Checkbox
                          color="secondary"
                          checked={child.R}
                          name={`attributes.Permission.${permissionKey}.SectionAccess.${sectionKey}.Access.R`}
                          disabled
                        />
                      </Box>
                      <Box
                        width={65}
                        flexGrow={1}
                        mr={2}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <Checkbox
                          color="secondary"
                          name={`attributes.Permission.${permissionKey}.SectionAccess.${sectionKey}.Access.U`}
                          checked={child.U}
                          disabled
                        />
                      </Box>
                    </Box>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </List>
        </Collapse>
      )}
    </Box>
  );
};

export default memo(PermissionDetail);
